import removeMd from "remove-markdown";

import { PopupActions } from "@store/popupStore";

export const handleCopyToClipboard = (text: string) => {
  navigator.clipboard.writeText(removeMd(text)).then(() => {
    PopupActions.openAlert({
      duration: 1000,
      message: "Copied to Clipboard",
      severity: "success",
    });
  });
};
